import { SettingsResource } from "./resources";

export function getSettings({ propertyId }) {
  return SettingsResource.get({ propertyId });
}
